import { useEffect } from 'react';

const useOutsideClick = (ref, onClickOutside, isEnabled = true) => {
  useEffect(() => {
    // If disabled (e.g., when pinned is true), don't attach the listener
    if (!isEnabled) return;

    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        // Prevent closing if the click is on a popover trigger
        if (event.target.closest('[data-popover-trigger]')) return;

        onClickOutside();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [ref, onClickOutside, isEnabled]);
};


export default useOutsideClick;
